"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readonlyAreaColor = exports.segmentationDrawColor = exports.negativeColorLighter = exports.positiveColorLighter = exports.negativeColor = exports.positiveColor = void 0;
var utils_1 = require("../../../utils");
exports.positiveColor = (0, utils_1.hslToStr)([195, 63, 53]);
exports.negativeColor = (0, utils_1.hslToStr)([0, 68, 61]);
exports.positiveColorLighter = (0, utils_1.hslToStr)([195, 73, 73]);
exports.negativeColorLighter = (0, utils_1.hslToStr)([0, 78, 81]);
exports.segmentationDrawColor = [136, 211, 236, 0.6];
exports.readonlyAreaColor = [80, 80, 80, 0.6];
